// import { getFaqBySlug } from "@/handlers/faq";
import dynamic from "next/dynamic";
// const ElectionPage = dynamic(() => import("@/screens/StateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
// import ElectionPage from "@/screens/StateElection";
// import PageLayout from "@/screens/Layout/PageLayout";
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";
import { stateData } from "@/constants/electionConfig";
// import OldElectionScreen from "@/screens/OldStateElection";
const OldElectionScreen = dynamic(() => import("@/screens/OldStateElection"));

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
}) {
  const isMobileDevice = useIsMobile();
  // let metaData = {
  //   title: `Maharashtra Assembly Elections 2024: Maharashtra Vidhan Sabha Chunav 2024 Full Schedule, महाराष्ट्र विधान सभा चुनाव अनुसूची - NewsTak`,
  //   description: `Maharashtra Vidhan Sabha Elections 2024: Get complete details about the Maharashtra Assembly Elections 2024 Schedule (विधानसभा चुनाव 2024 अनुसूची), including voting dates, key candidates, and election result dates at NewsTak.`,
  //   keywords: `Maharashtra Assembly Election Schedule, Maharashtra Assembly Election polling dates, Maharashtra Assembly Election results date, Maharashtra Assembly Election candidates, महाराष्ट्र विधानसभा चुनाव परिणाम, चुनाव समाचार,Maharashtra elections updates`,
  // };
  const state_data = stateData[electionCategory];

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <OldElectionScreen
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/schedule`}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          isMobileDevice={isMobileDevice}
          electionPassedCategory={
            state_data?.["schedule"]?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.["schedule"]?.state} //"Delhi"
          stateHindi={state_data?.["schedule"]?.stateHindi} //"महाराष्ट्र"
          metaData={state_data?.["schedule"]?.metaData}
          votingDate={state_data?.["schedule"]?.votingDate} //"20 नवंबर 2024"
          resultDate={state_data?.["schedule"]?.resultDate} //"23 नवंबर 2024"
          scheduleDesc={state_data?.["schedule"]?.scheduleDesc} //"288 सीटों वाले महाराष्ट्र विधानसभा के लिए 20 नंवबर को वोटिंग होगी और 23 नवंबर को मतगणना के बाद चुनाव परिणाम घोषित होंगे. महाराष्ट्र में महायुति और महाविकास अघाड़ी जैसे बड़े गठबंधन के अलावा बाकी पार्टियां जीत के लिए अपना पूरा दम लगाने में जुटी हैं. सत्तारूढ महायुति की सहयोगी पार्टी बीजेपी, शिवसेना (शिंदे), एनसीपी (अजित पवार) और इनके अन्य सहयोगी दल चुनावी मैदान में हैं. वहीं विपक्षी गठबंधन महाविकास अघाड़ी की सहयोगी पार्टी कांग्रेस, शिवसेना (उद्धव ठाकरे), एनसीपी (शरद पवार) समेत सहयोगी दल चुनाव लड़ रही हैं. इसके अलावा राज ठाकरे की मनसे के उम्मीदवार भी 25 सीटों पर ताल ठोंक चुके हैं. महाराष्ट्र की माहिम और वर्ली विधानसभा में चुनाव बेहद दिलचस्प हो गया है. इन सीटों पर राज ठाकरे की मनसे, शिंदे की शिवसेना और उद्धव की शिवसेना के बीच कड़ा मुकाबला हो गया है. महाराष्ट्र की 288 विधानसभा सीटों के लिए कुल 4,140 उम्मीदवार मैदान में हैं. सबसे कम उम्मीदवार नंदुरबार की शहादा सीट पर केवल 3 और बीड की माजलगांव सीट पर सबसे ज्यादा 34 उम्मीदवार हैं."
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";
  // console.log("delhi_data", electionCategory);
  let url = ctx?.resolvedUrl;
  url = url.split("/schedule")[0];
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");
 
  if(!stateData[electionCategory]){
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
